  import { Component } from '@angular/core';
  import { IonicPage, NavController, NavParams,LoadingController,AlertController } from 'ionic-angular';
  import {CommonProvider} from "../../providers/common/common";
  import {ThankuPage} from '../thanku/thanku';
  import { HomePage } from '../home/home';
  // import * as $ from "jquery";
  // declare var $;
  import $ from 'jquery'
  declare var $;
  import * as CryptoJS from 'crypto-js';
  import {GenericFormValidationProvider} from "../../providers/common/form-validation"
  // import { AllInOneSDK } from '@ionic-native/all-in-one-sdk';
  // import WLCheckout from "../../../weipl-checkout-cordova-master/www/WEIPL_checkout";
  import { AllInOneSdkProvider } from '../../providers/all-in-one-sdk/all-in-one-sdk'
  import { ActionSheetController } from 'ionic-angular';
  declare let window:any;
  declare var jQuery: any;
  declare let WLCheckout:any;
  /**
   * Generated class for the PartpaymentPage page.
   *
   * See https://ionicframework.com/docs/components/#navigation for more info on
   * Ionic pages and navigation.
   */

  @IonicPage()
  @Component({
    selector: 'page-partpayment',
    templateUrl: 'partpayment.html',
  })


  export class PartpaymentPage {
    previousData:any={};
    currentData:any={};
    payment_amount:any=0;
    // payment_amount:any=0
    errorDisplay:any={};
    token:any="";
    changePaymentOption:any="Change Tenure";

    constructor(private loadingCtrl:LoadingController,
      private fv : GenericFormValidationProvider,
      public navCtrl: NavController,
      public navParams: NavParams,private cp: CommonProvider,
      public actionSheetCtrl: ActionSheetController,
      private allInOneSdk : AllInOneSdkProvider,
      private alertCtrl:AlertController
      ) {
    }

    ionViewDidLoad() {
      if(this.navParams.data.paymentMode.length>0){
          this.navParams.data.paymentMode.forEach((res:any)=>{
          this.payment_amount=parseInt(this.payment_amount)+parseInt(res.chargeamt)
        })
      }
      
      this.previousData = this.navParams.data.loanParameterDetail.responseParameters[0]
      this.getNewPartPaymentDetails();
      this.previousData.transactionDetails =this.navParams.data.transactionDetails.loanDetailsBalancesODLimitInfo.principaloutstandingamount
      
     
    }
    changeEmiOpt(paymentOpt:any){
      this.changePaymentOption=paymentOpt;
       
    }
    getNewPartPaymentDetails(){
      let loading = this.loadingCtrl.create({
        content: 'Please wait...'
      });
      loading.present();
      var token=''
      var phone = localStorage.getItem("mobile");
      var loan = localStorage.getItem("cc");
      this.cp.generateToken(loading,loan).then((res:any)=>{
          // loading.dismiss()
        var res=JSON.parse(res)
          token=res.TokenKey;
          this.token=token
      
      this.cp.newPartPayment(loading,loan,phone,token).then((res:any)=>{
        loading.dismiss()  
        var res=JSON.parse(res)
        // ////////console.log(res.Payload);
        this.currentData=res.Payload;
        this.currentData.CurrentMonthEMICycle=this.previousData.emicycle?this.previousData.emicycle:""
      })
      }) 
      

    }
  removeZeroAmount(ev){
  if(this.payment_amount)
  this.payment_amount=parseInt(ev.target.value);
  }
paytmPayment(orderId,txnToken,amount){ 
  
    var that=this;
        var config = {
        "root": "",
        "flow": "DEFAULT",
        "data": {
        "orderId": orderId, //"", /* update order id */
        "token": txnToken, /* update token value */
        "tokenType": "TXN_TOKEN",

        "amount": amount, /* update amount */
        "isStaging": false,
        },
        "merchant": {
            "mid": "INDIAB40518225417073",//"INDIAB24704503981786",

        },
        "handler": {
          
          
          notifyMerchant:function notifyMerchant(eventName,data){
            // ////console.log("notify merchant about the payment state",data,eventName);
            if(eventName=='APP_CLOSED'){
              let responsePaytm:any={};
              responsePaytm.paytmaction = 'APP_CLOSED';
              that.updateTransaction(JSON.stringify( responsePaytm),'PAYTMWEB')
            }
          } 
        }
        };

  
        ////console.log(window.Paytm);
        if(window.Paytm && window.Paytm.CheckoutJS){
             window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
              // after successfully updating configuration, invoke JS Checkout
             window.Paytm.CheckoutJS.invoke();
        }).catch(function onError(error){
            ////console.log("error => ",error);
        });
        
    }

  }


techprocessPaymentGateway(){
 this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    ////////console.log(this.errorDisplay);
    if(this.errorDisplay.valid){
      return false;
    }else if(!this.payment_amount && this.payment_amount<=0){
        return false;
    }else{
      let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
      loading.present()
      let request:any={
            "Amount":this.payment_amount,
            "LanNo":localStorage.getItem("cc"),
            "PaymentRemark":"Advance EMI",
            "PartPaymentEffect":this.changePaymentOption,
            "Payment_Source":"TECHPROCESSWEB",
            "Userid":localStorage.getItem("mobile")
          }
         this.cp.createPaymentTrasaction(loading,request,this.token).then((resp:any)=>{
          loading.dismiss()
                  if(JSON.parse(resp).Message == 'FAILURE'){
                     alert(JSON.parse(resp).Displaymessage)
                    //this.navCtrl.setRoot(ThankuPage,{"res":JSON.stringify(JSON.parse(resp).Displaymessage)})
                    return false;
                  }else{
                    localStorage.setItem("localPaymentResponce",JSON.stringify(resp))
                 var that = this;
                 var txn=  JSON.parse(resp).Data[0].clnt_txn_ref//new Date().getTime();

                        var token="L1520|"+txn+"|"+that.payment_amount+"||||||||||||||4365446291ODRDJU"
                        var hashPwd = CryptoJS.SHA512(token).toString(CryptoJS.enc.Hex);
                        ////////console.log(hashPwd);
                 
                         var options = {
                                  "features": {
                                    'showPGResponseMsg': true,
                                    'enableExpressPay': false,
                                    'siDetailsAtMerchantEnd': false,
                                    'enableSI': false,
                                    'payDetailsAtMerchantEnd': false,
                                    "enableNewWindowFlow": false 
                                  },
                                  "consumerData": {
                                    "deviceId": this.cp.deviceTypePayment, //supported values "ANDROIDSH1" or "ANDROIDSH2" for Android, supported values "iOSSH1" or "iOSSH2" for iOS and supported values "WEBSH1" or "WEBSH2" for Browser
                                    "token": hashPwd,
                                    "returnUrl": this.cp.commonApiUrl+'/redirect',
                                    "paymentMode": "all",
                                    "merchantLogoUrl": "https://www.paynimo.com/CompanyDocs/company-logo-vertical-light.png",  //provided merchant logo will be displayed
                                    "merchantId": "L1520",
                                    "currency": "INR",
                                     
                                    "txnId": txn,   //Unique merchant transaction ID
                                    "items": [{
                                      "itemId": "IHFL_LOAN",
                                      "amount": this.payment_amount,
                                      "comAmt": "0"
                                    }],
                                    "customStyle": {
                                      "PRIMARY_COLOR_CODE": "#45beaa",   //merchant primary color code
                                      "SECONDARY_COLOR_CODE": "#FFFFFF",   //provide merchant's suitable color code
                                      "BUTTON_COLOR_CODE_1": "#2d8c8c",   //merchant's button background color code
                                      "BUTTON_COLOR_CODE_2": "#FFFFFF"   //provide merchant's suitable color code for button text
                                    }
                                  }
                };
                  var paymentCallback = function(response) {
                    // alert(JSON.stringify( response));
                    // //////console.log("techprocess payment",response);
                    this.updateTransaction(JSON.stringify( response),'TECHPROCESSWEB')
                    // this.navCtrl.setRoot(ThankuPage,{"res":JSON.stringify(response)})
                    // this.navCtrl.setRoot(HomePage)
                  }
                  var errorCallback = function(error) {
                    this.displayAlert(JSON.stringify( error),"");
                    // this.navCtrl.setRoot(ThankuPage,{"res":JSON.stringify(error)})
                    // this.navCtrl.setRoot(HomePage)
                  }
                  try{

                       $.pnCheckout(options);
                        if(options.features.enableNewWindowFlow){
                            // pnCheckoutShared.openNewWindow();
                        }
                    // WLCheckout.open(options, paymentCallback, errorCallback); 
                  }catch(err){
                    ////////console.log(err);
                  }

                  }
         })
       
  



        }


  }
 updateTransaction(resonce,type){
     let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
         
      this.cp.updatePayment(loading,resonce,type,this.token).then((res:any)=>{
        this.navCtrl.setRoot(ThankuPage, {data:JSON.stringify(res),"action":JSON.stringify(resonce),replaceUrl:true});
      })


    }
 
  presentActionSheet() {
    this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    ////////console.log(this.errorDisplay);
    if(this.errorDisplay.valid){
       this.displayAlert("Please enter the amount","")
      return false;
    }else if(!this.payment_amount && this.payment_amount<=0){
        this.displayAlert("Please enter the amount","")
        return false;
    }else{
        const actionSheet = this.actionSheetCtrl.create({
      title: '',
      cssClass: 'notcomman',
      buttons: [
        {
          text: 'Paytm',
          role: 'destructive',
          handler: () => {
            this.goToPaymentsEmi()
          }
        },{
          text: 'Techprocess',
          handler: () => {
             this.techprocessPaymentGateway()
          }
        }
      ]
    });
    actionSheet.present();
    }
  
  }

   displayAlert(msg,title){
      let masg=msg
      const alert = this.alertCtrl.create({
        title: title,
        subTitle: masg,
        buttons: ['OK']
      });
      alert.present();
   } 

  goToPaymentsEmi(){
   
        let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
        loading.present()
         
          this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
          ////////console.log(this.errorDisplay);
          if(this.errorDisplay.valid){
            return false;
          }else if(!this.payment_amount && this.payment_amount<=0){
              return false;
          }else{
            
           // orderid="ORDERID_"+orderid;
        
          let request:any={
            "Amount":this.payment_amount,
            "LanNo":localStorage.getItem("cc"),
            "PaymentRemark":"Advance EMI",
            "PartPaymentEffect":this.changePaymentOption,
            "Payment_Source":"paytm",
            "Userid":localStorage.getItem("mobile")
          }
          this.cp.createPaymentTrasaction(loading,request,this.token).then((resp:any)=>{
            var orderid=""
            orderid=JSON.parse(resp).Data[0].clnt_txn_ref;

            this.cp.newPaytmPayment(loading,orderid,this.payment_amount).then((res:any)=>{
                  console.log(JSON.parse(res))
                  loading.dismiss()
                  if(JSON.parse(resp).Message == 'FAILURE'){
                    this.displayAlert(JSON.parse(resp).Displaymessage,"")
                    return false;
                  }else{
                    localStorage.setItem("localPaymentResponce",JSON.stringify(resp))
                    this.paytmPayment(orderid,JSON.parse(res).body.txnToken,this.payment_amount)
                  }
                  
                      
               })

           
        
          
        })

  }        


}
       

      
  }





// WEBPACK FOOTER //
// ./src/pages/partpayment/partpayment.ts